import './migrationResult.component.scss';

// @vendor
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// @components
import { OKLayoutMigration } from '../layout/OKLayoutMigration';
import { OKBoxTitle } from 'commonsComponents/OKBoxTitle';
import { analyticsId, catalogue } from './analytics/migrationResult.tracking';
import { migrationKeys } from '../../migrationUsersBranchView.poeditor';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
import { recordLinkV2, recordProcess } from 'utilities/tagging';
import { goToGP } from '../../utilities/migration.utils';

// @constants
import { MIGRATION_STATE } from '../../migrationUsersBranchView.constants';
import { migrationResultKeys } from './migrationResult.component.poeditor';

const config = {
  [MIGRATION_STATE.MIGRATION_KO]: {
    title: migrationResultKeys.errorTitle,
    description: migrationResultKeys.errorDescription,
    descriptionInjectedString: formatTextFn => [
      `tel: ${formatTextFn(migrationKeys.migrationPhone)}`,
      formatTextFn(migrationKeys.migrationPhone),
    ],
    button: migrationResultKeys.errorButtonText,
    analytics: {
      page: '/migration/error/somethingWentWrong',
      step: 'error',
      screen: analyticsId.ERROR_VIEW,
      button: analyticsId.ERROR_VIEW_CLICK_BUTTON,
    },
    classnames: {
      icon: 'migration-result__error-icon',
    },
  },
  [MIGRATION_STATE.MIGRATION_SUCCESS]: {
    title: migrationResultKeys.successTitle,
    description: migrationResultKeys.successDescription,
    descriptionInjectedString: () => undefined,
    button: migrationResultKeys.successButtonText,
    analytics: {
      page: '/migration/success',
      step: 'success',
      screen: analyticsId.SUCCESS_VIEW,
      event: analyticsId.SUCCESS_EVENT,
      button: analyticsId.SUCCESS_VIEW_CLICK_BUTTON,
    },
    classnames: {
      icon: 'migration-result__success-icon',
    },
  },
};

export const MigrationResult = ({ migrationState }) => {
  const handleClickOutside = event => {
    if (event?.srcElement?.innerText === formatText(migrationKeys.migrationPhone)) {
      recordLinkV2(catalogue[analyticsId.ERROR_VIEW_CLICK_PHONE]());
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const immScreen = useSelector(state => state.screen);
  useEffect(() => {
    window.utag_last_name = config[migrationState].analytics.page;
    recordProcess(
      'proc-migracion',
      config[migrationState].analytics.step,
      catalogue[config[migrationState].analytics.screen](
        formatText(
          config[migrationState].description,
          config[migrationState].descriptionInjectedString(formatText)
        )
      ),
      true
    );
    if (config[migrationState].analytics.event) {
      recordLinkV2(catalogue[config[migrationState].analytics.event]());
    }
  }, []);

  const history = useHistory();
  return (
    <OKLayoutMigration
      footer={{
        rightSideButton: {
          modifier: immScreen.get('isMobile') ? 'primary' : 'link-complementary',
          text: formatText(config[migrationState].button),
          handler: () => {
            recordLinkV2(catalogue[config[migrationState].analytics.button]());
            goToGP(history);
          },
        },
      }}
    >
      <div className="migration-result">
        <i className={config[migrationState].classnames.icon} />
        <div className="migration-result__messages">
          <OKBoxTitle value={formatText(config[migrationState].title)} />
          <div className="migration-result__messages--description">
            <FormattedText
              value={config[migrationState].description}
              injectedStrings={config[migrationState].descriptionInjectedString(formatText)}
            />
          </div>
        </div>
      </div>
    </OKLayoutMigration>
  );
};
